
scrollTop('block_top-scroll-btn', 200); 

function scrollTop(el, duration) {
  const target = document.getElementById(el);
  target.addEventListener('click', function() {
    let currentY = window.scrollY;
    let step = duration/currentY > 1 ? 10 : 100;
    let timeStep = duration/currentY * step; 
    let intervalId = setInterval(scrollUp, timeStep);
    function scrollUp(){
      currentY = window.scrollY;
      if(currentY === 0) {
          clearInterval(intervalId); 
      } else {
          scrollBy( 0, -step ); 
      }
    }
  });
}

let lastKnownScrollPosition ;

document.addEventListener("scroll", (event) => {
  lastKnownScrollPosition = window.scrollY;
   if(lastKnownScrollPosition > 1500){    
     document.querySelector("#shopify-section-top-scroll .page-width").classList.remove("hidden");
   }else{
     document.querySelector("#shopify-section-top-scroll .page-width").classList.add("hidden");
   }
});

